"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prove = exports.disprove = void 0;
var F = __importStar(require("../Formula"));
var Util_1 = require("../Util");
var ImplicationIndex_1 = __importDefault(require("./ImplicationIndex"));
var Queue_1 = __importDefault(require("./Queue"));
var Prover = /** @class */ (function () {
    function Prover(implications, traits) {
        var _this = this;
        if (traits === void 0) { traits = new Map(); }
        this.traits = traits;
        this.proofs = new Map();
        this.queue = new Queue_1.default(implications);
        traits.forEach(function (_, id) {
            _this.proofs.set(id, 'given');
            _this.queue.mark(id);
        });
    }
    Prover.build = function (implications, traits) {
        return new Prover(new ImplicationIndex_1.default(implications), new Map(traits));
    };
    Prover.prototype.apply = function (implication) {
        var a = implication.when;
        var c = implication.then;
        var av = F.evaluate(a, this.traits);
        var cv = F.evaluate(c, this.traits);
        if (av === true && cv === false) {
            return this.contradiction(implication.uid, Util_1.union(F.properties(a), F.properties(c)));
        }
        else if (av === true) {
            return this.force(implication.uid, c, F.properties(a));
        }
        else if (cv === false) {
            return this.force(implication.uid, F.negate(a), F.properties(c));
        }
    };
    Prover.prototype.run = function () {
        var theorem;
        while (theorem = this.queue.shift()) {
            var contradiction = this.apply(theorem);
            if (contradiction) {
                return contradiction;
            }
        }
    };
    Prover.prototype.derivations = function () {
        var _this = this;
        var contradiction = this.run();
        if (contradiction) {
            return { contradiction: contradiction };
        }
        var proofs = [];
        this.traits.forEach(function (value, property) {
            var proof = _this.proof(property);
            if (!proof || proof === 'given') {
                return;
            }
            proofs.push({ property: property, value: value, proof: proof });
        });
        return { proofs: proofs };
    };
    Prover.prototype.proof = function (property) {
        var proof = this.proofs.get(property);
        switch (proof) {
            case 'given': return 'given';
            case undefined: return undefined;
            default: return this.expand(proof.theorem, proof.properties);
        }
    };
    Prover.prototype.contradiction = function (theorem, properties) {
        return this.expand(theorem, Array.from(properties));
    };
    Prover.prototype.expand = function (theorem, properties) {
        var theoremByProperty = new Map();
        var assumptions = new Set();
        var queue = Array.from(properties);
        var expanded = new Set();
        var property;
        while (property = queue.shift()) {
            if (expanded.has(property)) {
                continue;
            }
            var proof = this.proofs.get(property);
            if (proof === 'given' || (proof && proof.theorem === 'given')) {
                expanded.add(property);
                assumptions.add(property);
            }
            else if (proof) {
                theoremByProperty.set(property, proof.theorem);
                expanded.add(property);
                queue = queue.concat(proof.properties);
            }
        }
        return {
            theorems: Array.from(theoremByProperty.values()).concat(theorem),
            properties: Array.from(assumptions)
        };
    };
    Prover.prototype.force = function (theorem, formula, support) {
        switch (formula.kind) {
            case 'and':
                return this.forceAnd(theorem, formula, support);
            case 'atom':
                return this.forceAtom(theorem, formula, support);
            case 'or':
                return this.forceOr(theorem, formula, support);
        }
    };
    Prover.prototype.forceAtom = function (theorem, formula, support) {
        var property = formula.property;
        if (this.traits.has(property)) {
            if (this.traits.get(property) !== formula.value) {
                return this.contradiction(theorem, new Set(property));
            }
            else {
                return;
            }
        }
        this.traits.set(property, formula.value);
        this.proofs.set(property, {
            theorem: theorem,
            properties: Array.from(support)
        });
        this.queue.mark(property);
    };
    Prover.prototype.forceAnd = function (theorem, formula, support) {
        for (var _i = 0, _a = formula.subs; _i < _a.length; _i++) {
            var sub = _a[_i];
            var contradiction = this.force(theorem, sub, support);
            if (contradiction) {
                return contradiction;
            }
        }
    };
    Prover.prototype.forceOr = function (theorem, formula, support) {
        var _this = this;
        var result = formula.subs.reduce(function (acc, sf) {
            if (!acc) {
                return undefined;
            }
            var value = F.evaluate(sf, _this.traits);
            if (value === true) {
                return undefined; // Can't force anything
            }
            else if (value === false) {
                acc.falses.push(sf);
            }
            else if (acc.unknown) {
                return undefined; // Can't determine which to force
            }
            else {
                acc.unknown = sf;
            }
            return acc;
        }, { falses: Array(), unknown: undefined });
        if (!result)
            return;
        var falseProps = Util_1.union.apply(void 0, result.falses.map(F.properties));
        if (result.falses.length === formula.subs.length) {
            return this.contradiction(theorem, falseProps);
        }
        else if (result.unknown) {
            return this.force(theorem, result.unknown, Util_1.union(support, falseProps));
        }
    };
    return Prover;
}());
exports.default = Prover;
function disprove(implications, formula) {
    var proof;
    var prover = new Prover(implications);
    proof = prover.force('given', formula, new Set());
    if (proof) {
        return formatProof(proof);
    }
    proof = prover.run();
    if (proof) {
        return formatProof(proof);
    }
}
exports.disprove = disprove;
function prove(theorems, when, then) {
    return disprove(new ImplicationIndex_1.default(theorems), F.and(when, F.negate(then)));
}
exports.prove = prove;
var formatProof = function (proof) {
    var filtered = proof.theorems.filter(function (id) { return id !== 'given'; });
    return filtered.length > 0 ? filtered : 'tautology';
};
